export const interfaceHe = {
  "Asymmetric meshes": "רשתות אסימטריות",
  "Retry PDF preview": "ניסיון נוסף להצגת PDF",
  "Choose PDF language": "בחירת שפת PDF",
  "Preparing PDF": "מכין PDF…",
  "PDF generation failed": "לא ניתן ליצור את ה־PDF. נסו שוב.",
  "Cancel PDF download": "ביטול",

  "Loading PDF page": "טוען עמוד PDF…",
  "PDF page could not be displayed": "לא ניתן להציג את העמוד. ניתן להוריד את ה־PDF או לנסות עמוד אחר.",
  "Enter Company Name": "הזנת שם החברה",
  "Enter Your Last Name": "הזנת שם משפחה",
  "Enter Your Phone Number": "הזנת מספר טלפון",
  "Enter Your Email": "הזנת כתובת דוא״ל",
  "Enter Your Password": "הזנת סיסמה",
  "Enter Your Job Title": "הזנת תפקיד",
  "Enter Your First Name": "הזנת שם פרטי",
  "Phone number must be 9 or 10 digits": "מספר הטלפון חייב להכיל 9 או 10 ספרות",
  "Generating PDF": "יוצר PDF",
  "Type your full name": "הזנת שם מלא",
  "Type your phone number": "הזנת מספר טלפון",
  "Type your job": "הזנת תפקיד",
  "Loading...": "טוען...",
  "Company": "חברה",
  "create new": "יצירה חדשה",
  "Edit": "עריכה",
  "Add New": "הוספה חדשה",
  "project": "פרויקט",
  "creator": "יוצר ההזמנה",
  "create a user": "יצירת משתמש",
  "Your": "ההזמנה שלך",
  "order has been successfully saved.": "נשמרה בהצלחה.",
  "What’s next?": "מה השלב הבא?",
  "go to my orders": "לרשימת ההזמנות שלי",
  "create a new order": "יצירת הזמנה חדשה",
  "(NIS)": "(₪)",
  "NIS": "₪",
  "Price": "מחיר",
  "Total": "סך הכול",
  "Price (NIS)": "מחיר (₪)",
  "Suppliers Prices": "מחירי ספקים",
  "You can enter the prices of your supplier, and see the costs of each item in the document. This way you can also avoid mistakes easily.": "ניתן להזין את מחירי הספק ולראות את העלות של כל פריט במסמך, כדי למנוע טעויות.",
  "* Required field to see price line": "* שדה חובה להצגת שורת מחיר",
  "Suppliers": "ספקים",
  "Choose your supplier": "בחירת הספק",
  "Price List": "מחירון",
  "Rebars": "מוטות",
  "Price per ton": "מחיר לטון",
  "Cuts": "חיתוכים",
  "Bending": "כיפוף",
  "Extra for 2D hoops": "תוספת לחישוקים דו־ממדיים",
  "Nets": "רשתות",
  "Standard Nets": "רשתות סטנדרטיות",
  "Special Nets": "רשתות מיוחדות",
  "Extra for bending nets": "תוספת לכיפוף רשתות",
  "Pile cages": "כלונסאות",
  "Symmetrical standard pile cage": "כלונס סימטרי סטנדרטי",
  "Special pile cage": "כלונס מיוחד",
  "Extra for Gama pile / Diameter: 2 inch": "תוספת לכלונס גאמה / קוטר: 2 צול",
  "Extra for Gama pile / Diameter: 2.5 inch": "תוספת לכלונס גאמה / קוטר: 2.5 צול",
  "cancel": "ביטול",
  "save": "שמירה",
  "Select Type": "בחירת סוג",
  "Previous PDF page": "עמוד PDF קודם",
  "Next PDF page": "עמוד PDF הבא",
  "Close PDF preview": "סגירת תצוגת PDF",
  "Duplicating order...": "משכפל את ההזמנה...",
  "This may take a few seconds.": "התהליך עשוי לקחת מספר שניות.",
  "Do not close or refresh this page.": "אין לסגור או לרענן את העמוד.",
  "Order duplicated successfully": "ההזמנה שוכפלה בהצלחה",
  "A new copy was created. Stay in the order list or edit the new order.": "נוצר עותק חדש של ההזמנה. ניתן להישאר ברשימת ההזמנות או לעבור לעריכת ההזמנה החדשה.",
  "New order number": "מספר ההזמנה החדשה",
  "Stay in orders": "הישאר בעמוד ההזמנות",
  "Edit new order": "עריכת ההזמנה החדשה",
  "Copy order number": "העתק מספר הזמנה",
  "Duplicate order": "שכפול הזמנה",
  "Business ID": "ח.פ",
  "New": "חדש",
  "Select company": "בחירת חברה",
  "Search by company name": "חיפוש לפי שם החברה",
  "Add new company": "הוספת חברה חדשה",
  "No matching companies": "לא נמצאו חברות מתאימות",
  "Heading": "כותרת",
  "Use a heading to separate elements": "בעזרת הכותרת ניתן להפריד אלמנטים",
  "Notes to supplier": "הערות לספק",
  "Packaging, markings, welding and other notes...": "הערות לגבי אריזה, סימונים, ריתוכים וכדומה...",
  "Save and lock heading": "שמירת ונעילת הכותרת",
  "Heading options and dragging": "אפשרויות וגרירת כותרת",
  "Options and dragging": "אפשרויות וגרירה",
  "Delete": "מחיקה",
  "Heading:": "כותרת:",
  "Notes to supplier:": "הערות לספק:",
  "Add heading": "הוספת כותרת",
  "Send to factory": "שלח למפעל",
  "Processing and waste": "עיבוד ופחת",
  "Cutting (kg)": "חיתוך (ק״ג)",
  "Bending (kg)": "כיפוף (ק״ג)",
  "Units": "יחידות",
  "Waste 3% (tons)": "פחת 3% (טון)",
  "Total including waste (tons)": "סה״כ כולל פחת (טון)",
  "Diameters": "קטרים",
  "Total sum": "סה״כ",
  "Length (m)": "אורך (מטר)",
  "Weight (kg)": "משקל (ק״ג)",
  "Order": "הזמנה",
  "Bars": "מוטות",
  "Standard meshes": "רשתות סטנדרטיות",
  "Piles": "כלונסאות",
  "Weight (tons)": "משקל (טון)",
  "Recipient email": "כתובת האימייל של הנמען",
  "Notes": "הערות",
  "Optional email message": "הודעה שתצורף למייל, לא חובה",
  "Factory name": "שם המפעל",
  "Enter factory name": "הקלד שם מפעל",
  "Factory email": "כתובת אימייל המפעל",
  "Date": "תאריך",
  "User": "משתמש",
  "Changes": "מה השתנה",
  "Polygonal steel | Diameters: 8-25 mm": "פלדה מצולעת | קטרים: 8–25 מ״מ",
  "Polygonal steel | Diameters: 28-36 mm": "פלדה מצולעת | קטרים: 28–36 מ״מ",
  "Round steel | Diameters: 6-12 mm": "פלדה עגולה | קטרים: 6–12 מ״מ",
  "Round steel | Diameters: above 12 mm": "פלדה עגולה | קטרים: מעל 12 מ״מ",
  "Extra for Gama pile | Diameter: 2 inch": "תוספת לכלונס גאמה | קוטר: 2 צול",
  "Extra for Gama pile | Diameter: 2.5 inch": "תוספת לכלונס גאמה | קוטר: 2.5 צול"
};
